<template>
  <div class="home">
    <brewery-list v-show="!adminStatus && !brewerStatus" />
    <brewer-list v-if="brewerStatus" />
    <admin-table v-if="adminStatus" />
  </div>
</template>

<script>
import AdminTable from '../components/AdminTable.vue';
import { defineComponent } from 'vue';
import BreweryList from '../components/BreweryList.vue';
import BrewerList from '@/components/BrewerList.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    BreweryList,
    AdminTable,
    BrewerList
  },
  data () {
    return {
      adminStatus: this.$store.state.adminStatus,
      brewerStatus: this.$store.state.brewerStatus
    }
  }
});
</script>
